import React from "react"
import { AnimatePresence, MotionConfig } from "framer-motion"

import AssistantMobileBottomSheet from "~components/outfitter-assistant/assistant-mobile-bottom-sheet"
import AssistantPanel from "~components/outfitter-assistant/assistant-panel"
import useIsOutfitterAssistantAvailable from "~utils/hooks/use-is-outfitter-assistant-available"
import { useIsMobile } from "~utils/hooks/use-responsive"
import { useOutfitterAssistant } from "~contexts/outfitter-assistant-provider"

export default function OutfitterAssistant() {
    const isAvailable = useIsOutfitterAssistantAvailable()
    const { isOpen, close } = useOutfitterAssistant()
    const isMobile = useIsMobile()

    if (!isAvailable) {
        return null
    }

    return (
        <MotionConfig reducedMotion="user">
            <AnimatePresence>
                {isOpen &&
                    (isMobile ? (
                        <AssistantMobileBottomSheet onClose={close} />
                    ) : (
                        <AssistantPanel />
                    ))}
            </AnimatePresence>
        </MotionConfig>
    )
}
